import Donation from '@/components/Donation'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		data: {},
		...opts,
		vueComponent: Donation
	}

	let page = vuewidget(dom, options)
	return page
}
